import { render } from "./app-logo-gobiz.vue?vue&type=template&id=aca0e7d0"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/image/app-logo-gobiz.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "aca0e7d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('aca0e7d0', __exports__)) {
    console.log('reload')
    api.reload('aca0e7d0', __exports__)
  }
  
  module.hot.accept("./app-logo-gobiz.vue?vue&type=template&id=aca0e7d0", () => {
    console.log('re-render')
    api.rerender('aca0e7d0', render)
  })

}


export default __exports__